const ITEMS = [
  "RIGHT PARTNER",
  "RIGHT PATH",
  "RIGHT GROWTH",
  "SAN FRANCISCO",
  "SILICON VALLEY",
  "LOS ANGELES",
  "BRANDING",
  "DIGITAL ADS & SEO",
  "GOOGLE ADS",
  "META ADS",
  "YELP ADS",
  "WEB DEVELOPMENT",
  "SOCIAL & CONTENT",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-amber-500/15 bg-[#0A1128]/60 py-5"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-mono text-xs uppercase tracking-[0.35em] text-amber-300/70 px-8">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-amber-500/50" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
